// Exports the "image" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/image')
//   ES2015:
//     import 'tinymce/plugins/image'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_tinymce@4.9.4@tinymce/plugins/image/index.js
// module id = mnm3
// module chunks = 0